import {Injector, ModuleWithProviders, NgModule} from '@angular/core';
import {FlewDefinitionService} from './flew-definition.service';
export class FlewModule {
private static injector: Injector;
private static definition: FlewDefinitionService;
/**
 * @param {?} dependency
 * @return {?}
 */
public static getInjector(dependency: any) {
        if (FlewModule.injector) {
            return FlewModule.injector.get(dependency);
        }
    }
/**
 * @return {?}
 */
public static get translate() {
        const /** @type {?} */ dependency = FlewModule.getInjector(FlewModule.definition.translate);
        if (!dependency) {
            throw new Error(`Can't resolve translator dependency:
                    - Do you provided the dependency in AppModule(Angular Main Module)?`);
        }
        return dependency;
    }
/**
 * @return {?}
 */
public static get notifier() {
        const /** @type {?} */ dependency = FlewModule.getInjector(FlewModule.definition.notifier);
        if (!dependency) {
            throw new Error(`Can't resolve notifier dependency:
                    - Do you provided the dependency in AppModule(Angular Main Module)?`);
        }
        return dependency;
    }
/**
 * @return {?}
 */
public static get transformSuccess() {
        if (!FlewModule.definition) {
            throw new Error(`Can't resolve the definition service for FlewModule
                    - Review your forRoot implementation in AppModule(Angular Main Module)`);
        }
        return FlewModule.definition.transformSuccess;
    }
/**
 * @return {?}
 */
public static get transformError() {
        if (!FlewModule.definition) {
            throw new Error(`Can't resolve the definition service for FlewModule
                    - Review your forRoot implementation in AppModule(Angular Main Module)`);
        }
        return FlewModule.definition.transformError;
    }
/**
 * @return {?}
 */
public static get success() {
        return FlewModule.definition.success;
    }
/**
 * @param {?} definition
 * @return {?}
 */
static forRoot(definition): ModuleWithProviders {
        return {
            ngModule: FlewModule,
            providers: [{provide: FlewDefinitionService, useValue: definition}]
        };
    }
/**
 * @param {?} injector
 * @param {?} definition
 */
constructor(injector: Injector, definition: FlewDefinitionService) {
        FlewModule.injector = injector;
        FlewModule.definition = definition;
    }
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [],
    exports: [],
    declarations: []
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Injector, },
{type: FlewDefinitionService, },
];
}

function FlewModule_tsickle_Closure_declarations() {
/** @type {?} */
FlewModule.injector;
/** @type {?} */
FlewModule.definition;
/** @type {?} */
FlewModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
FlewModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
